import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

export default function EquipmentCard({ equipment, onBook }) {
  return (
    <Card
      data-testid={`equipment-card-${equipment.id}`}
      className="rounded-sm border border-border bg-white overflow-hidden flex flex-col group hover:border-secondary transition-colors"
    >
      <div className="relative h-48 overflow-hidden bg-muted">
        <img
          src={equipment.image}
          alt={equipment.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {equipment.popular && (
          <Badge
            data-testid={`popular-badge-${equipment.id}`}
            className="absolute top-3 left-3 rounded-sm bg-orange-500 hover:bg-orange-500 text-white uppercase font-heading tracking-wider text-[10px]"
          >
            Most Hired
          </Badge>
        )}
        <div className="absolute top-3 right-3 bg-white/95 border border-border px-2 py-1 text-[10px] uppercase tracking-wider font-heading">
          {equipment.category}
        </div>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-heading uppercase text-xl tracking-tight">
          {equipment.name}
        </h3>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          {equipment.short_desc}
        </p>

        <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs">
          {Object.entries(equipment.specs)
            .slice(0, 4)
            .map(([k, v]) => (
              <li key={k} className="flex flex-col">
                <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
                  {k}
                </span>
                <span className="font-medium text-secondary truncate">{v}</span>
              </li>
            ))}
        </ul>

        <div className="mt-5 pt-5 border-t border-border flex items-center justify-end">
          <Button
            data-testid={`book-${equipment.id}`}
            onClick={onBook}
            className="btn-sharp bg-orange-500 hover:bg-orange-600 text-white font-heading uppercase tracking-wider w-full"
          >
            Inquire Now <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </Card>
  );
}
